import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './heart-behind-p2.component.html',
  styleUrls: ['./heart-behind-p2.component.scss']
})
export class HeartBehindP2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
